"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargeCardsResponse = exports.ChargeCard = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ChargeCardStatus_1 = require("./enums/ChargeCardStatus");
class ChargeCard extends base_models_1.Serializable {
}
exports.ChargeCard = ChargeCard;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '1D6A9B05000001',
        description: 'Vandebron RFID',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeCard.prototype, "rfid", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'NL-ESS-C00000005-H',
        description: 'Vandebron card number',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'card_number' }),
    tslib_1.__metadata("design:type", String)
], ChargeCard.prototype, "cardNumber", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: 'Active',
        description: 'Card status',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(ChargeCardStatus_1.ChargeCardStatus),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargeCard.prototype, "status", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '2030-07-31T13:01:22Z',
        description: 'ISO formatted expiration date',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)({ name: 'expires_at' }),
    tslib_1.__metadata("design:type", String)
], ChargeCard.prototype, "expiresAt", void 0);
class ChargeCardsResponse extends base_models_1.Serializable {
}
exports.ChargeCardsResponse = ChargeCardsResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: [
            {
                rfid: '1D6A9B05000001',
                card_number: 'NL-ESS-C00000005-H',
                status: 'Active',
                expires_at: '2030-07-31T13:01:22Z',
            },
        ],
        description: 'Customer charge cards',
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ChargeCard),
    tslib_1.__metadata("design:type", Array)
], ChargeCardsResponse.prototype, "results", void 0);
